import React from "react";
import Link from "gatsby-link";
import styles from "./PostListing.module.scss";

class PostListing extends React.Component {
  getPostList() {
    const postList = [];
    this.props.postEdges.forEach(postEdge => {
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.cover,
        title: postEdge.node.frontmatter.title,
        date: postEdge.node.frontmatter.date,
        excerpt: postEdge.node.excerpt,
        timeToRead: postEdge.node.timeToRead
      });
    });
    return postList;
  }
  render() {
    const postList = this.getPostList();
    return (
      <div className={styles.postlistcontainer}>
        {/* Your post list here. */
        postList.map(post =>
          <article className={styles.articleexcerpt}>
            <div className="row">
              <div className="col-md-4 d-flex align-self-stretch">
                  <img src={post.cover} alt={post.title} className="img-fluid d-flex align-self-center" />
              </div>
              
              <div className="col-md-8">
                <span className="date">{post.date.substr(6,2)+"/"+post.date.substr(4,2)+"/"+post.date.substr(0,4)}</span>
                <Link to={post.path} key={post.title}>
                  <h1>
                    {post.title}
                  </h1>
                </Link>
                <div class={styles.postexcerpt}>
                  {post.excerpt}
                </div>
                <div class={styles.postshowmore}>
                    <a href={post.path} className="btn btn-primary" title={post.title}>Lire la suite</a>
                </div>
              </div>
            </div>
          </article>
        )}
      </div>
    );
  }
}

export default PostListing;



// WEBPACK FOOTER //
// ./src/components/PostListing/PostListing.jsx